<template>
  <a
    :href="footerLink.href"
    :target="footerLink.target"
    :rel="footerLink.rel"
    class="lead-channel-primary-color text-decoration-none"
  >{{ footerLink.label }}</a>
</template>

<script>
  export default {
    props: {
      footerLink: {
        type: Object,
        required: true
      }
    }
  };
</script>
